<template>
  <div class="not-found">
    <div class="mask"></div>

    <div class="content">
      <h1>404</h1>

      <h2>页面不存在</h2>

      <p>
        抱歉，您访问的页面不存在，可能已被删除或链接地址有误。
      </p>

      <el-button type="primary" round @click="goHome">
        返回首页
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",

  methods: {
    goHome() {
      this.$router.push("/");
      // 如果没有 vue-router：
      // window.location.href = "/";
    }
  }
};
</script>

<style scoped>
.not-found {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  /* 换成你的背景图 */
  background: url() center center no-repeat;
  background-size: cover;
}

/* 遮罩 */
.mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .35);
}

/* 中间卡片 */
.content {
  position: relative;
  z-index: 2;

  width: 90%;
  max-width: 520px;

  padding: 50px 40px;

  text-align: center;

  border-radius: 18px;

  background: rgba(255,255,255,.18);

  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);

  border: 1px solid rgba(255,255,255,.3);

  box-shadow: 0 10px 40px rgba(0,0,0,.2);
}

h1 {
  margin: 0;
  font-size: 110px;
  color: #fff;
  line-height: 1;
  font-weight: bold;
}

h2 {
  margin: 20px 0 10px;
  font-size: 34px;
  color: #fff;
}

p {
  margin: 0 auto 35px;
  line-height: 28px;
  color: rgba(255,255,255,.9);
  font-size: 16px;
}

.el-button {
  width: 180px;
  height: 46px;
  font-size: 16px;
}

/* ======================= */
/* 平板 */
/* ======================= */
@media (max-width: 768px) {

  .content {
    padding: 40px 25px;
  }

  h1 {
    font-size: 90px;
  }

  h2 {
    font-size: 28px;
  }

  p {
    font-size: 15px;
    line-height: 24px;
  }

}

/* ======================= */
/* 手机 */
/* ======================= */
@media (max-width: 480px) {

  .content {
    width: 92%;
    padding: 35px 20px;
  }

  h1 {
    font-size: 70px;
  }

  h2 {
    font-size: 24px;
  }

  p {
    font-size: 14px;
    line-height: 22px;
  }

  .el-button {
    width: 100%;
  }

}
</style>